import { FC } from "react";
import gsap from "gsap";
import { BaseProps } from "./text";
import GText from "./GText";
import useScrollTrigger from "../../functions/useScrollTrigger";
import { css } from "@emotion/react";

interface Props {
  text?: string;
}

const GTextRotateUp: FC<Props & BaseProps> = (props) => {
  const styles = css`
    position: relative;
    display: inline-block;
    padding-right: 0.05em;
    overflow: hidden;
    font-weight: inherit;

    & .letter {
      transform-origin: 0 100%;
      display: inline-block;
      line-height: 1em;
      white-space: break-spaces;
      transform: rotateZ(100deg) translate(0.55em, 1.4em);
    }
  `;

  const { ref } = useScrollTrigger(() => {
    gsap.timeline().to(ref.current?.children as gsap.TweenTarget, {
      y: 0,
      x: 0,
      z: 0,
      rotationZ: 0,
      duration: 0.7,
      ease: "expo.out",
      stagger: (index) => (index * 80) / 1000,
    });
  });

  const splitTextIntoSpan = () => {
    return props.text?.split("").map((l, i) => (
      <span className="letter" key={i}>
        {l}
      </span>
    ));
  };

  return (
    <GText {...props}>
      <div ref={ref} css={styles} className="g-text-grow">
        {splitTextIntoSpan()}
      </div>
    </GText>
  );
};

GTextRotateUp.defaultProps = {
  text: "Grooody",
  color: "#000",
  fontSize: 50,
  fontWeight: "bold",
};

export default GTextRotateUp;

// We need to add the below in framer
/*
addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
})
*/
